import { render, staticRenderFns } from "./InputCalendario.vue?vue&type=template&id=36770c3b&scoped=true&"
import script from "./InputCalendario.vue?vue&type=script&lang=js&"
export * from "./InputCalendario.vue?vue&type=script&lang=js&"
import style0 from "./InputCalendario.vue?vue&type=style&index=0&id=36770c3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36770c3b",
  null
  
)

export default component.exports